import { useContext, useEffect } from 'react'
import style from './SelectionPage.module.css'
import labsLogo from '../../assets/images/logo-mekyal-saudi.webp'
import engLogo from '../../assets/images/Picture1-150x150.webp'
import bgLabsMosaic1 from '../../assets/images/bg-company-mosaic .webp'
import bgCompanyMosaic from '../../assets/images/bg-company-mosaic .webp'
import bgSelectionPattern from '../../assets/images/bg-selection-pattern.webp'
import { useTranslation } from 'react-i18next'
import { LangContext } from '../context/LangContext'
import { Link } from 'react-router-dom'
import * as motion from "motion/react-client"

export default function SelectionPage() {

  const { t } = useTranslation()
  let { language } = useContext(LangContext)

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const labsSite = () => {
    document.documentElement.classList.remove('company')
    sessionStorage.setItem('desiredPage', 'labs')
  }

  const companySite = () => {
    document.documentElement.classList.add('company')
    sessionStorage.setItem('desiredPage', 'company')
  }

  return <>
    <div
      className={`${style.pageWrap} ${language === 'en' ? 'roboto-font' : 'cairo-font'}`}
      style={{ backgroundImage: `url(${bgSelectionPattern})` }}
    >

      {/* Header */}
      <div className={style.headerBlock}>
        <h1 className={`${style.mainTitle} ${style.font3}`}>
          <span className={`roboto-font ${style.titleEn}`}>AlMekyal AlSaudi Group</span>
          <span className={style.titleAr}>مجموعة المكيال السعودي</span>
        </h1>

        <div className={style.divider}>
          <span className={style.dividerLine}></span>
          <span className={style.dividerDiamond}></span>
          <span className={style.dividerLine}></span>
        </div>

        <p className={`${style.introText} ${style.font5}`}>{t("textSelection")}</p>
      </div>

      {/* Cards */}
      <div className={`row justify-content-center gx-4 gy-4 ${style.cardsRow}`}>

        {/* Labs card */}
        <div className="col-md-6 col-lg-5">
          <motion.div
            initial={{ y: 40, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.3, duration: 0.7, ease: "easeOut" }}
            className={`${style.card} ${style.cardLabs}`}
          >
            {/* <div className={style.cardBg} style={{ backgroundImage: `url(${bgLabsMosaic1})`,position: 'absolute' }}></div> */}
            <div className={`position-absolute bg-white rounded-circle d-flex align-items-center justify-content-center ${style.circleLogo} ${style.top}`}>
              <img className={style.logoImg} src={labsLogo} alt="labs logo" />
            </div>
            <div className={style.cardContent}>
              <h3 className={`${style.cardTitle} ${style.font5}`}>{t("lab1")}</h3>
              <p className={style.cardSubtitle}>{t("lab2")}</p>
              <span className={style.cardDivider}></span>
              <Link to={'/'} onClick={labsSite} className={style.visitBtn}>
                <span className={style.arrow}>←</span>
                {t("visitSite")}
              </Link>
            </div>
          </motion.div>
        </div>

        {/* Company card */}
        <div className="col-md-6 col-lg-5">
          <motion.div
            initial={{ y: 40, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.5, duration: 0.7, ease: "easeOut" }}
            className={`${style.card} ${style.cardCompany}`}
          >
            {/* <div className={style.cardBg} style={{ backgroundImage: `url(${bgCompanyMosaic})`, backgroundSize: 'cover !important' }}></div> */}
            <div className={`position-absolute bg-white rounded-circle d-flex align-items-center justify-content-center ${style.circleLogo} ${style.top}`}>
              <img className={style.logoImg} src={engLogo} alt="eng logo" />
            </div>
            <div className={style.cardContent}>
              <h3 className={`${style.cardTitle} ${style.font5}`}>{t("company1")}</h3>
              <p className={style.cardSubtitle}>{t("company2")}</p>
              <span className={style.cardDivider}></span>
              <Link to={'/'} onClick={companySite} className={style.visitBtn} style={{ borderColor: '#A4915A' }}>
                <span className={style.arrow}>←</span>
                {t("visitSite")}
              </Link>
            </div>
          </motion.div>
        </div>
      </div>
      <span className="d-flex align-items-center justify-content-center roboto-font small text-center w-100 py-2 mt-auto">
        Copyright © ElMekyal AlSaudi {new Date().getFullYear()} Powered by&nbsp;
        <Link className="fw-semibold text-black" to={'https://mas-itc.com'} target='_blank'> MAS-ITC</Link>
      </span>
    </div>
  </>
}